export default { sha: 'ba1e87f72e9cfc7b74bf9ddb35c311e1157ea3f8', buildNumber: 'undefined' }
